export const validateRegisterForm = (data) => {
  const errors = {};

  // validate last name
  if (!data.Last_name) {
    errors.Last_name = "請輸入姓名";
  }

  // validate email
  if (!data.emailsignup) {
    errors.emailsignup = "請輸入電子郵件信箱";
  } else if (!/\S+@\S+\.\S+/.test(data.emailsignup)) {
    errors.emailsignup = "請輸入有效的電子郵件信箱";
  }

  // validate password
  if (!data.passwordsignup) {
    errors.passwordsignup = "請輸入密碼";
  } else {
    const passwordLength = data.passwordsignup.length;
    const hasUpperCase = /[A-Z]/.test(data.passwordsignup);
    const hasLowerCase = /[a-z]/.test(data.passwordsignup);
    const hasNumber = /[0-9]/.test(data.passwordsignup);

    if (passwordLength < 8 || passwordLength > 12) {
      errors.passwordsignup = "密碼長度必須為8-12位";
    } else if (!(hasUpperCase && hasLowerCase && hasNumber)) {
      errors.passwordsignup = "密碼必須包含大寫字母、小寫字母和數字";
    }
  }

  // validate confirm password
  if (data.passwordsignup !== data.passwordsignup_confirm) {
    errors.passwordsignup_confirm = "兩次輸入的密碼不一致";
  }

  // validate service terms
  if (!data.agreepolicy) {
    errors.agreepolicy = "請同意服務條款和隱私權聲明";
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

export const validateLoginForm = (data) => {
  const errors = {};

  // validate username
  if (!data.username) {
    errors.username = "請輸入電子郵件信箱";
  } else if (!/\S+@\S+\.\S+/.test(data.username)) {
    errors.username = "請輸入有效的電子郵件信箱";
  }

  // validate password
  if (!data.password) {
    errors.password = "請輸入密碼";
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

export const validateForgotPasswordForm = (data) => {
  const errors = {};

  // validate email
  if (!data.email) {
    errors.email = "請輸入電子郵件信箱";
  } else if (!/\S+@\S+\.\S+/.test(data.email)) {
    errors.email = "請輸入有效的電子郵件信箱";
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

export const validateRegisterStep1Form = (data) => {
  const errors = {};

  // validate email
  if (!data.email) {
    errors.email = "請輸入電郵地址";
  } else if (!/\S+@\S+\.\S+/.test(data.email)) {
    errors.email = "請輸入有效的電郵地址";
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

export const validateRegisterStep2Form = (data, code, number, t) => {
  const errors = {};

  // validate last name
  if (!data.lastName) {
    errors.lastName = "請輸入姓名";
  }

  // validate first name
  if (!data.firstName) {
    errors.firstName = "請輸入名字";
  }



  // // validate phone
  // if (!data.phoneNumber) {
  //   errors.phoneNumber = "請輸入電話號碼";
  // } else if (!/^\d{8,}$/.test(data.phoneNumber)) {
  //   errors.phoneNumber = "請輸入有效的電話號碼";
  // }

  // // validate password
  // if (!data.password) {
  //   errors.password = "請輸入密碼";
  // } else {
  //   const passwordLength = data.password.length;
  //   const hasUpperCase = /[A-Z]/.test(data.password);
  //   const hasLowerCase = /[a-z]/.test(data.password);
  //   const hasNumber = /[0-9]/.test(data.password);

  //   if (passwordLength < 8 || passwordLength > 12) {
  //     errors.password = "密碼長度必須為8-12位";
  //   } else if (!(hasUpperCase && hasLowerCase && hasNumber)) {
  //     errors.password = "密碼必須包含大寫字母、小寫字母和數字";
  //   }
  // }

  // // validate confirm password
  // if (data.password !== data.confirmPassword) {
  //   errors.confirmPassword = "兩次輸入的密碼不一致";
  // }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

export const validatePTagAirPaymentForm = (data) => {
  const errors = {};

  // validate recipient name
  if (!data.recipient) {
    errors.recipient = "請輸入收件人姓名";
  }

  // validate phone number - only allow numbers
  if (!data.recipientPhone) {
    errors.recipientPhone = "請輸入聯絡電話";
  } else if (!/^\d+$/.test(data.recipientPhone)) {
    errors.recipientPhone = "聯絡電話只能包含數字";
  } else if (data.recipientPhone.length < 8) {
    errors.recipientPhone = "請輸入有效的電話號碼";
  }

  // validate email format
  if (!data.recipientEmail) {
    errors.recipientEmail = "請輸入電郵地址";
  } else if (!/\S+@\S+\.\S+/.test(data.recipientEmail)) {
    errors.recipientEmail = "請輸入有效的電郵地址";
  }

  // validate shipping method
  if (!data.shippingMethod) {
    errors.shippingMethod = "請選擇送貨方法";
  }

  // validate shipping address
  if (!data.shippingAddress) {
    errors.shippingAddress = "請輸入送貨地址";
  }

  // validate payment method
  if (!data.payment) {
    errors.payment = "請選擇付款方法";
  }

  // validate pet name
  if (!data.petName) {
    errors.petName = "請輸入寵物名稱";
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

export const validateLastName = (lastName, t) => {
  if (!lastName) return t('EnterLastName');
  if (/\d/.test(lastName)) return t('LastNameCannotContainNumbers');
  return "";
};


// Individual validation functions for real-time validation
export const validatePhoneNumber = (phone, t) => {
  if (!phone) return t('EnterPhoneNumber');
  if (!/^\d+$/.test(phone)) return t('OnlyNumbers');
  if (phone.length < 8) return t('InvalidPhoneNumber');
  
  return "";
};

export const validatePhoneNumberbyCode2 = (data, t) => {
  if (!data.phoneNumber2) return "";
  if (!/^\d+$/.test(data.phoneNumber2)) return t('OnlyNumbers');
  if (data.phoneCode === "+852" && data.phoneNumber2.length !== 8) return t('InvalidPhoneNumber');
  if (data.phoneCode === "+853" && data.phoneNumber2.length !== 8) return t('InvalidPhoneNumber');
  if (data.phoneCode === "+86" && data.phoneNumber2.length !== 11) return t('InvalidPhoneNumber');
  if (data.phoneCode === "+81" && data.phoneNumber2.length !== 10) return t('InvalidPhoneNumber');
  if (data.phoneCode === "+880" && data.phoneNumber2.length !== 10) return t('InvalidPhoneNumber');
  return "";
};

// Individual validation functions for real-time validation
export const validatePhoneNumberbyCode = (data) => {
  if (!data.phoneNumber2) return "請輸入聯絡電話";
  if (!/^\d+$/.test(data.phoneNumber2)) return "聯絡電話只能包含數字";
  if (data.phoneCode === "+852" && data.phoneNumber2.length !== 8) return "請輸入有效的電話號碼";
  if (data.phoneCode === "+853" && data.phoneNumber2.length !== 8) return "請輸入有效的電話號碼";
  if (data.phoneCode === "+86" && data.phoneNumber2.length !== 11) return "請輸入有效的電話號碼";
  if (data.phoneCode === "+81" && data.phoneNumber2.length !== 10) return "請輸入有效的電話號碼";
  if (data.phoneCode === "+880" && data.phoneNumber2.length !== 10) return "請輸入有效的電話號碼";
  return "";
};

export const validateEmail = (email, t) => {
  if (!email) return t('EnterEmail');
  if (!/\S+@\S+\.\S+/.test(email)) return t('InvalidEmail');
  return "";
};

// Validation for pet form phone numbers
export const validatePetPhoneNumber = (phone, isRequired = true) => {
  if (!phone && isRequired) return "請輸入聯絡電話";
  if (phone && phone.length < 8) return "請輸入有效的電話號碼";
  return "";
};

// Validation for chip numbers (only numbers allowed)
export const validateChipNumber = (chipNumber) => {
  if (chipNumber && !/^\d+$/.test(chipNumber)) {
    return "晶片號碼只能包含數字";
  }
  return "";
};

// Validation for parity information (only numbers allowed)
export const validateParityInfo = (parityInfo) => {
  if (parityInfo && !/^\d+$/.test(parityInfo)) {
    return "胎次資訊只能包含數字";
  }
  return "";
};
